// extracted by mini-css-extract-plugin
export var activityContainer = "_na-0";
export var typingIndicatorContainer = "_na-1";
export var typingIndicatorDot = "_na-2";
export var wave = "_na-3";